const starting_context = {
    team:"",
    trafus_teams : [{
        "name":'Team 1',
        "id":1
    }],
    trafus_users :[
        {"full_name":"Test One The Human",
        "user_name":"test_1",
        "id":1,
        "team_id":1,
        "password":"password"}
    ],
    trafus_categories :[]
    ,trafus_expenses:[]
}

export default starting_context